module.exports = __webpack_public_path__ + "img/icon-profile@3x.a6cebd69.jpg";